import createTabManager from './tabManagerFactory'
import tabs from 'components/Demands/tabs'

const treatmentDemandTabs = createTabManager(tabs)

export default treatmentDemandTabs



// WEBPACK FOOTER //
// ./client/store/modules/tabs/treatmentDemandTabs.js